import { Box, Drawer, Image, TextInput } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { FC } from 'react';
import { SearchIcon, scanIcon } from '../../assets';
import GlobalSearch from '../../components/GlobalSearch';
import { useSearchBarStyles } from './styles';

const SearchBar: FC = () => {
  const { classes, cx } = useSearchBarStyles();

  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Box style={{ display: 'flex', gap: 8, padding: 8 }}>
        <TextInput
          onClick={() => open()}
          placeholder='Search ...'
          readOnly
          rightSection={<Image src={SearchIcon} />}
          styles={(theme) => ({
            root: {
              width: '100%',
              height: 'auto',
              flexGrow: 1,
            },
            wrapper: {
              width: '100%',
              height: '100%',
            },
            input: {
              height: '100%',
              width: '100%',
              minHeight: '100%',
              borderRadius: 12,
              border: 'none',
              boxShadow: '0px 4px 11px 0px rgba(0,0,0,0.1)',
            },
          })}
        />
        <Box className={classes.qrCodeWrapperBox}>
          <Image withPlaceholder src={scanIcon} width={'100%'} height={'100%'} />
        </Box>
      </Box>

      <Drawer opened={opened} onClose={close} position='top' size='xl'>
        <GlobalSearch close={close} />
      </Drawer>
    </>
  );
};

export default SearchBar;
